import { Repository } from "./adapters/repository";

import * as addResourceGroup from "./useCases/addResourceGroup";
import * as retrieveResourceGroups from "./useCases/retrieveResourceGroups";
import * as removeResourceGroup from "./useCases/removeResourceGroup";
import * as editResourceGroup from "./useCases/editResourceGroup";
import * as addResourceToResourceGroup from "./useCases/addResourceToResourceGroup";
import * as removeResourceFromResourceGroup from "./useCases/removeResourceFromResourceGroup";
import * as addEveryoneToResourceGroup from "./useCases/addEveryoneToResourceGroup";
import * as retrieveResourceGroup from "./useCases/retrieveResourceGroup";

enum UseCases {
  addResourceGroup = "addResourceGroup",
  retrieveResourceGroups = "retrieveResourceGroups",
  removeResourceGroup = "removeResourceGroup",
  editResourceGroup = "editResourceGroup",
  addResourceToResourceGroup = "addResourceToResourceGroup",
  removeResourceFromResourceGroup = "removeResourceFromResourceGroup",
  addEveryoneToResourceGroup = "addEveryoneToResourceGroup",
  retrieveResourceGroup = "retrieveResourceGroup",
}

interface Core {
  [UseCases.addResourceGroup]: addResourceGroup.Interactor;
  [UseCases.retrieveResourceGroups]: retrieveResourceGroups.Interactor;
  [UseCases.removeResourceGroup]: removeResourceGroup.Interactor;
  [UseCases.editResourceGroup]: editResourceGroup.Interactor;
  [UseCases.addResourceToResourceGroup]: addResourceToResourceGroup.Interactor;
  [UseCases.removeResourceFromResourceGroup]: removeResourceFromResourceGroup.Interactor;
  [UseCases.addEveryoneToResourceGroup]: addEveryoneToResourceGroup.Interactor;
  [UseCases.retrieveResourceGroup]: retrieveResourceGroup.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore({ repository }: Dependencies): Core {
  return {
    [UseCases.addResourceGroup]: addResourceGroup.createInteractor(repository),
    [UseCases.retrieveResourceGroups]:
      retrieveResourceGroups.createInteractor(repository),
    [UseCases.removeResourceGroup]:
      removeResourceGroup.createInteractor(repository),
    [UseCases.editResourceGroup]:
      editResourceGroup.createInteractor(repository),
    [UseCases.addResourceToResourceGroup]:
      addResourceToResourceGroup.createInteractor(repository),
    [UseCases.removeResourceFromResourceGroup]:
      removeResourceFromResourceGroup.createInteractor(repository),
    [UseCases.addEveryoneToResourceGroup]:
      addEveryoneToResourceGroup.createInteractor(repository),
    [UseCases.retrieveResourceGroup]:
      retrieveResourceGroup.createInteractor(repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
